import { useLayoutEffect, useState, useCallback } from "react";

const useSticky = () => {
  const [sticky, setSticky] = useState(false);
  const [headerHeight, setHeaderHeight] = useState(0);

  // Measure header height once on mount
  useLayoutEffect(() => {
    const header = document.getElementById("header-sticky");
    if (header) {
      const height = header.offsetHeight;
      setHeaderHeight(height);
      // Add a CSS variable for the header height
      document.documentElement.style.setProperty(
        "--header-height",
        `${height}px`
      );
    }
  }, []);

  const stickyHeader = useCallback((): void => {
    const scrollY = window.scrollY;
    const shouldBeSticky = scrollY > headerHeight;

    if (shouldBeSticky !== sticky) {
      // Use requestAnimationFrame for smooth state updates
      requestAnimationFrame(() => {
        setSticky(shouldBeSticky);
      });
    }
  }, [sticky, headerHeight]);

  useLayoutEffect(() => {
    // Check initial position
    stickyHeader();

    // Use passive listener and throttle for performance
    let ticking = false;
    const onScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          stickyHeader();
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener("scroll", onScroll, { passive: true });

    return (): void => {
      window.removeEventListener("scroll", onScroll);
    };
  }, [stickyHeader]);

  return {
    sticky,
  };
};

export default useSticky;
